import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/vaadin': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6v-12.3c0-12.2 9.3-22.1 21.5-22.1s21.5 9.9 21.5 22.1v36.5c0 42.9-21.5 62-66.8 62h-100.5c-30.1 0-33 14.7-33 27.1 0 1.3-0.1 2.5-0.2 3.7-0.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-0.1-1.2-0.2-2.4-0.2-3.7 0-12.3-3-27.1-33-27.1h-100.7c-45.3 0-66.8-19.1-66.8-62v-36.5c0-12.2 9.4-22.1 21.6-22.1 12.2 0 21.5 9.9 21.5 22.1v12.3c0 13.8 11.4 21.6 32.1 21.6h98.6c44.8 0 48.3 35.1 49.8 52.7h0.9zM224 456c-11.5 0-21.4-7-25.7-16.3-1.1-1.8-97.1-169.5-98.2-171.4-11.9-19.7 3.2-44.3 27.2-44.3 13.9 0 23.4 6.4 29.8 20.3l66.9 117.7 66.9-117.7c6.5-13.9 15.9-20.3 29.8-20.3 24 0 39.1 24.7 27.2 44.3-1.1 1.8-97.1 169.6-98.2 171.4-4.3 9.3-14.2 16.3-25.7 16.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/vaadin.js
// module id = 1075
// module chunks = 0